import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appResizable]'
})
export class ResizableDirective {
  @Output() resize = new EventEmitter<number>(); 
  @Output() resizing = new EventEmitter<boolean>(); 
  private isResizing = false;

  constructor(private el: ElementRef) {}

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    const clickedElement = event.target as HTMLElement;
    if (clickedElement.id=='resizerDivId'){
      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('mouseup', this.onMouseUp);
      this.isResizing = true;
      this.resizing.emit(this.isResizing);
      document.body.classList.add('hide-cursor');
      document.body.classList.add('no-select');
      document.body.classList.add('disabled-div');
    }

  }

  onMouseMove = (event: MouseEvent) => {
    if (this.isResizing) {
      const parentRect = this.el.nativeElement.parentElement.getBoundingClientRect();
      const relativeX = event.clientX - parentRect.left;
      this.resize.emit(relativeX);
    }
  };

  onMouseUp = (event: MouseEvent) => {
      this.isResizing = false;
      document.body.classList.remove('hide-cursor');
      document.body.classList.remove('no-select');
      document.body.classList.remove('disabled-div');
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('mouseup', this.onMouseUp);
      this.resizing.emit(this.isResizing);
  };
}